var exports = {
  "fs": "SpaceBackground.module__starfield___U0ppWW",
  "UB": "SpaceBackground.module__starDrift___U0ppWW",
  "hi": "SpaceBackground.module__spaceBackground___U0ppWW" + " " + "SpaceBackground.module__starfield___U0ppWW",
};

module.exports = exports;
